<template>
  <div class="form-fields-edit--wrap">
    <v-btn
      color="appMain"
      class="form-fields-edit"
      v-if="item.editing && !definition.inline_edits"
      @click.prevent="doneEditing(item)"
    >
      Done Editing
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'doneEditing',
  props: ['item', 'lessonId'],
  computed: {
    definition() {
      return this.$store.getters['items/type'](this.item.type) || {};
    },
  },
  methods: {
    doneEditing() {
      this.item.editing = false;
    },
  },
};
</script>

<style scoped lang="less">
.form-fields-edit--wrap {
  padding: 24px 16px 16px;
  background: #fff;
}
</style>
